import React from 'react';
// import ContactForm from "./ContactForm";
// import GoogleMapStyle from "./GoogleMapStyle";
import { FiHeadphones , FiMail , FiMonitor } from "react-icons/fi";

const ContactOne = () => {
    return (
        <>
            <div className="row row--15">
                <div className="col-lg-12">
                    <div className="rn-contact-address mt_dec--30">
                        <div className="row">

                            {/* <div className="col-lg-4 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Contact Phone Number</h4>
                                        <p><a href="tel:+444 555 666 777">+444 555 666 777</a></p>
                                        <br />
                                        <br />
                                        <p />
                                    </div>
                                </div>
                            </div> */}

                            {/* <div className="col-lg-6 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Our Email Address</h4>
                                        <p><a target="blank" href="mailto:info@hermesgroup.com">info@hermesgroup.com</a></p>  
                                        <p />
                                    </div>
                                </div>
                            </div> */}

                            <div className="col-lg-12 col-md-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMonitor />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Follow Us On Social Media</h4>
                                        <p><a target="blank" href="https://www.facebook.com/Bayonne-Voices-for-Progress-109522598581427">Facebook</a></p>
                                        {/* <p><a target="blank" href="https://twitter.com">Twitter</a></p>
                                        <p><a target="blank" href="https://instagram.com">Instagram</a></p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="row mt--40 row--15">
                <div className="col-lg-7">
                    <ContactForm formStyle="contact-form-1" />
                </div>
                <div className="col-lg-5 mt_md--30 mt_sm--30">
                    <GoogleMapStyle />
                </div>
            </div> */}
        </>
    )
}
export default ContactOne;